<template>
  <section class="report_branches-list-wrapper">
    <div class="report_branches-list-filter px-1">
      <form @submit.prevent="filterResults">
        <div class="row align-items-end border rounded py-2 mb-2">
          <div class="col-12 col-sm-6 col-lg-9">
            <label for="report_branches-list-verified">Ara</label>
            <fieldset class="form-group mb-0">
              <input class="form-control" id="report_branches-list-verified" v-model="search" />
            </fieldset>
          </div>
          <div class="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
            <button type="button" @click="filterResults" class="btn btn-primary btn-block glow report_branches-list-clear mt-0">{{  $t('general.filter') }}</button>
            <button type="button" @click="resetFilters" class="btn btn-primary btn-block glow report_branches-list-clear mt-0 ml-1">{{  $t('general.clear') }}</button>
          </div>
        </div>
      </form>
    </div>
    <div class="report_branches-list-table">
      <div class="card">
        <div class="card-body">
          <!-- datatable start -->
          <div class="table-responsive">
            <data-table
                tableVariant="''"
                :hover="false"
                :outlined="false"
                :striped="false"
                :no-border-collapse="true"
                :borderless="true"
                :bordered="false"
                @onClickDelete="onClickDelete"
                @onClickEdit="onClickEdit"
                :items="formattedItems"
                :fields="fields"
                :per-page.sync="per_page"
                :page.sync="page"
                :paginate="items"
            ></data-table>

          </div>
          <!-- datatable ends -->

          <add-button @onClick="onClickAdd" />

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DataTable from "@/assets/components/dataTable/DataTable";
import inputFilter from "@/assets/components/filters/InputFilter";
import addButton from "@/assets/components/dataTable/AddButton";
import baseModule, {
  ERROR,
  LOADING,
  MODULE_NAME as BASE_MODULE,
  SUCCESS,
  BRANCHES as ITEMS,
  GET_BRANCHES as GET_ITEMS,
} from "@/core/services/store/report.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

import {
  LARAVEL_DATE_TIME_FORMAT,
  MOMENT_SYSTEM_DATE_FORMAT
} from "@/core/config/constant";
import moment from "moment";

export default {
  name: "BranchIndex",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
  },
  components: {
    DataTable,
    DashboardBox,
    inputFilter,
    addButton
  },
  computed: {
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    loading() {
      return store.getters[_BASE_MODULE + "/" + LOADING];
    },
    success() {
      return store.getters[_BASE_MODULE + "/" + SUCCESS];
    },
    items() {
      return store.getters[_BASE_MODULE + "/" + ITEMS];
    },
    filters() {
      return {
        per_page: this.per_page,
        page: this.page,
        search: this.search,
        order: this.order,
        sort: this.sort
      };
    },
    formattedItems() {
      let results = [];
      if (
        this.items === null ||
        this.items.data === null ||
        this.items.data === undefined
      )
        return [];

      this.items.data.forEach(item => {
        let createdAt = item.created_at
          ? moment(item.created_at, LARAVEL_DATE_TIME_FORMAT)
          : moment();
        results.push({
          id: item.id,
          institution_id: item.institution ? item.institution.name : '-',
          name: item.name,
          service_count: item.services_count,
          status: item.status ? this.$t("general.active") : this.$t("general.passive"),
          created_at: createdAt.format(MOMENT_SYSTEM_DATE_FORMAT)
        });
      });

      return results;
    }
  },
  data() {
    return {

      page: 1,
      per_page: 10,
      sort: "id",
      order: "desc",
      search: "",
      fields: [
        {
          key: "id",
          label: this.$t("reports.branches.id"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "institution_id",
          label: this.$t("reports.branches.institution"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "name",
          label: this.$t("reports.branches.name"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "status",
          label: this.$t("reports.branches.status"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "service_count",
          label: this.$t("reports.branches.service_count"),
          sortable: false,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "created_at",
          label: this.$t("reports.branches.created_at"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        }
      ]
    };
  },
  methods: {
    filterResults() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch(_BASE_MODULE + '/' + GET_ITEMS, {
          filters: this.filters,
        });
    },
    onClickDelete(id) {
      this.sweetAlertConfirm(
        this.$t("general.are_you_sure"),
        function(self) {
          let payload = {
            id: id
          };
          self.$store.dispatch(_BASE_MODULE + "/" + DELETE_ITEM, payload);
        });
    },
    onClickAdd() {
      this.$router.push({ name: 'management.reports.branches.create' })
    },
    onClickEdit(id) {
      this.$router.push({ name: "management.reports.branches.edit", params: { id: id } });
    },
    filterResult() {
      this.$store.dispatch(_BASE_MODULE + "/" + GET_ITEMS, {
        url: this.url,
        filters: this.filters
      });
    },
    resetFilters() {
      this.search = "";
    this.filterResults();
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("reports.branches.self") }
    ]);
    this.filterResults();
  },
  watch: {
    sort() {
      this.filterResults();
    },
    order() {
      this.filterResults();
    },
    per_page() {
      this.filterResults();
    },
    page() {
      this.filterResults();
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self
              .sweetAlertSuccess(self.$t("general.successfully_saved"), (response) => {
                if (response) {
                  this.filterResults();
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style>
.filter-card {
  background: white;
  border-radius: 25px !important;
  padding: 20px;
}
</style>
